<template>
  <PDFOMP :back_as_landing_page="true" :rotta_back="'/home/dashboard'"/>
</template>
<script>
import PDFOMP from "@/views/TOOLS/PDFOMP.vue";

export default {
  name: "OMPPdfConvert",
  components: { PDFOMP },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      // Modal
      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>